/* MARCA | 08 Apr 2026 | Cart upsell accordion with recently viewed products carousel */
if (!customElements.get('cart-upsell-products')) {
  class CartUpsellProducts extends HTMLElement {
    static _cachedHTML = null;
    static _cacheTimestamp = 0;

    connectedCallback() {
      const hasServerProducts = this.querySelector('.swiper-slide');

      if (hasServerProducts) {
        this.initCarousel();
        return;
      }

      if (CartUpsellProducts._cachedHTML && Date.now() - CartUpsellProducts._cacheTimestamp < 30000) {
        this.renderCached();
        return;
      }

      this.loadRecentlyViewed();
    }

    get swiperWrapper() {
      return this.querySelector('.swiper-wrapper');
    }

    get slideContainer() {
      return this.querySelector('.swiper');
    }

    get sliderNext() {
      return this.querySelector('.swiper-button-next');
    }

    get sliderPrev() {
      return this.querySelector('.swiper-button-prev');
    }

    renderCached() {
      if (!this.swiperWrapper || !CartUpsellProducts._cachedHTML) return;
      this.swiperWrapper.innerHTML = CartUpsellProducts._cachedHTML;
      this.showAccordion();
      this.initCarousel();
    }

    loadRecentlyViewed() {
      var items = JSON.parse(window.localStorage.getItem('sleektheme:recently-viewed') || '[]');

      if (items.length === 0) {
        this.hideAccordion();
        return;
      }

      var cartProductIds = (this.dataset.cartProductIds || '').split(',').filter(Boolean);
      var filtered = items.filter(function (id) {
        return !cartProductIds.includes(String(id));
      });

      if (filtered.length === 0) {
        this.hideAccordion();
        return;
      }

      var limit = parseInt(this.dataset.limit) || 6;
      var queryParams = filtered
        .slice(0, limit)
        .map(function (id) {
          return 'id:' + id;
        })
        .join(' OR ');
      var url = this.dataset.searchUrl + encodeURIComponent(queryParams);
      var self = this;

      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var slides = doc.querySelectorAll('.swiper-slide');

          if (!self.swiperWrapper || slides.length === 0) {
            self.hideAccordion();
            return;
          }

          slides.forEach(function (slide) {
            self.swiperWrapper.appendChild(slide.cloneNode(true));
          });

          CartUpsellProducts._cachedHTML = self.swiperWrapper.innerHTML;
          CartUpsellProducts._cacheTimestamp = Date.now();

          self.showAccordion();
          self.initCarousel();
        })
        .catch(function (err) {
          console.error('[CartUpsell] Failed to load products:', err);
          self.hideAccordion();
        });
    }

    showAccordion() {
      var accordion = this.closest('details');
      if (accordion) {
        accordion.removeAttribute('hidden');
        accordion.setAttribute('open', '');
      }
      var wrapper = this.closest('[id^="CartDrawerUpsell"]');
      if (wrapper) wrapper.removeAttribute('hidden');
    }

    hideAccordion() {
      var accordion = this.closest('details');
      if (accordion) accordion.setAttribute('hidden', '');
      var wrapper = this.closest('[id^="CartDrawerUpsell"]');
      if (wrapper) wrapper.setAttribute('hidden', '');
    }

    initCarousel() {
      if (!this.slideContainer || !window.FoxTheme || !window.FoxTheme.Carousel) return;

      var slides = this.slideContainer.querySelectorAll('.swiper-slide');
      if (slides.length === 0) return;

      var nav = this.querySelector('.slider-controls');
      if (nav && slides.length <= 1) nav.hidden = true;

      this.carousel = new FoxTheme.Carousel(this.slideContainer, {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: false,
        navigation: {
          nextEl: this.sliderNext,
          prevEl: this.sliderPrev,
        },
      });

      if (this.carousel) this.carousel.init();
    }
  }

  customElements.define('cart-upsell-products', CartUpsellProducts);
}
